<template>
  <div :ref="'rm_' + index" class="rm">
    <!-- <div @click="selectRegistrationMethod(index)" class="rm-header row">
      <div class="row">
        <div class="col col-15 text-center"><input @input="selectRegistrationMethod(index)" class="input-radio" :id="'rm_'+index" name="rm" type="radio" :value="index"></div>
        <div class="col col-85">
          <label class="text-left" :for="'rm_'+index">
            <p class="mb-0 mt-0 lh-1-6"><strong>{{registration_method.name}}</strong></p>
            <p class="mb-0 mt-0 text-16 lh-1-6" v-if="this.generateDescription(registration_method)">{{this.generateDescription(registration_method)}}</p>
          </label>
        </div>
      </div>
    </div> -->
    <div v-if="selected == index" class="rm-form row">
      <!-- SPECIAL REVERB LOOKUP METHOD -->
      <div v-if="registration_method.registration_method_id == 1">
        <div class="row mb-15">
          <input
            v-model="form.last_name"
            class="input-text"
            placeholder="Last Name"
            type="text"
          />
        </div>
        <div class="row mb-15">
          <input
            v-model="form.room_number"
            class="input-text"
            placeholder="Room Number"
            type="text"
          />
        </div>
      </div>
      <!-- END SPECIAL LOOKUP METHOD -->
      <!-- SPECIAL REVERB SIGNUP METHOD -->
      <div v-if="registration_method.registration_method_id == 3">
        <div class="row mb-15">
          <input
            v-model="form.first_name"
            class="input-text"
            placeholder="First Name"
            type="text"
          />
        </div>
        <div class="row mb-15">
          <input
            v-model="form.last_name"
            class="input-text"
            placeholder="Last Name"
            type="text"
          />
        </div>
        <div class="row mb-15">
          <input
            v-model="form.email_address"
            class="input-text"
            placeholder="Email"
            type="text"
          />
        </div>
        <div class="row mb-15 checkbox-row">
          <label for="checkbox-consent" style="display: inline;">
            <input
              id="checkbox-consent"
              v-model="form.consent"
              type="checkbox"
            />
            <span>I accept the </span>
          </label>
          <span class="text-link" @click="selectTermsOfService(index)"
            >Terms and Conditions</span
          >
          <span v-if="selected_error" class="error-text"
            >You must agree to the Terms and Conditions to get online.</span
          >
          <label for="checkbox-marketing">
            <input
              id="checkbox-marketing"
              v-model="form.marketing"
              type="checkbox"
            />
            <span>I'd like to recieve marketing materials from Reverb.</span>
          </label>
        </div>
      </div>
      <!-- END SPECIAL SIGN UP METHOD -->
      <div
        v-if="registration_method.registration_method_id == 4"
        class="row mb-15 p-rel"
      >
        <input
          v-model="access_code"
          class="input-text"
          placeholder="Access Code"
          type="text"
        />
        <span v-if="!access_code_valid" class="error-text">{{
          access_code_error_text
        }}</span>
      </div>
      <div class="mb-15">
        <button
          :style="
            'background: ' +
            color_background_button +
            '; color: ' +
            color_text_button
          "
          class="btn top-btn"
          type="button"
          @click="emitRegistrationMethodData()"
        >
          Continue
        </button>
      </div>
      <p
        v-if="registration_method.registration_method_id !== 3"
        class="text-center text-14 mb-0"
      >
        By clicking continue you agree to the
        <span class="text-link" @click="selectTermsOfService(index)"
          >Terms and Conditions</span
        >
      </p>
      <div
        v-if="selected_tos == index"
        class="terms-of-service text-left pt-20"
      >
        <div v-html="registration_method.terms_of_service"></div>
        <div class="mt-30 text-center">
          <button class="btn-close" @click="selectTermsOfService(null)">
            CLOSE
          </button>
        </div>
      </div>
    </div>
  </div>
  <!-- rm -->
</template>
<script>
export default {
  name: "registration_method",
  props: [
    "index",
    "selected",
    "selected_tos",
    "color_background_button",
    "color_text_button",
    "registration_method",
  ],
  data() {
    return {
      access_code: null,
      access_code_valid: true,
      access_code_error_text: "Required",
      selected_error: false,
      form: {
        first_name: "",
        last_name: "",
        room_number: "",
        email_address: "",
        consent: true,
        marketing: false,
      },
    };
  },
  // watch: {
  //   'selected':function(){
  //     this.$el.querySelector( '#rm_' + this.index ).checked = (this.selected == this.index);
  //   }
  // },
  mounted() {
    // this.$el.querySelector( '#rm_' + this.index ).checked = (this.selected == this.index);
  },
  methods: {
    // Generate the description that appears below the Registration Method name
    generateDescription: function (rm) {
      if (rm.type != "rateplan") return null;
      let description = "";
      if (parseInt(rm.price) === 0) {
        description += "Connect";
      } else {
        description += "$" + rm.price;
      }

      description += " for ";

      if (rm.duration >= 1440) {
        if (rm.duration % 1440 > 0) {
          description += " more than ";
        }
        var whole_days = Math.floor(rm.duration / 1440);
        description += whole_days + " day";
        if (whole_days > 1) {
          description += "s";
        }
      } else if (rm.duration >= 60) {
        if (rm.duration % 60 > 0) {
          description += " more than ";
        }
        var whole_hours = Math.floor(rm.duration / 60);
        description += whole_hours + " hour";
        if (whole_hours > 1) {
          description += "s";
        }
      } else {
        description += rm.duration + " minute";
        if (rm.duration > 1) {
          description += "s";
        }
      }

      description += " with ";
      if (rm.additional_devices > 0) {
        description += "up to " + rm.additional_devices + " devices";
      } else {
        description += "1 device";
      }
      if (rm.speed_upload && rm.speed_download) {
        description +=
          " (" + rm.speed_upload + " Up / " + rm.speed_download + " Down)";
      }
      return description;
    },
    // Send selected Registration Method back to parent
    selectRegistrationMethod: function (index) {
      this.$emit("changeSelected", index);
    },
    // Send selected Terms of Service back to parent
    selectTermsOfService: function (index) {
      this.$emit("changeSelectedTOS", index);
    },
    // Manipulate and send registration method data back to parent
    emitRegistrationMethodData: function () {
      // If no access code set, show required text
      if (this.registration_method.type == "accesscode" && !this.access_code) {
        this.access_code_valid = false;
        return;
      }
      var emitted = {
        registration_method_id: this.registration_method.registration_method_id,
        rateplan_id: null,
        email_address: null,
        last_name: null,
        room_number: null,
        access_code: null,
      };
      if (this.registration_method.registration_method_id == "1") {
        emitted.last_name = this.form.last_name;
        emitted.room_number = this.form.room_number;
        emitted.rateplan_id = this.registration_method.id;
      } else if (this.registration_method.registration_method_id == "2") {
        emitted.rateplan_id = this.registration_method.id;
        emitted.last_name = this.form.last_name;
        emitted.room_number = this.form.room_number;
      } else if (this.registration_method.registration_method_id == "3") {
        emitted.last_name = this.form.last_name;
        emitted.first_name = this.form.first_name;
        emitted.rateplan_id = this.registration_method.id;
        emitted.email_address = this.form.email_address;
        emitted.consent = this.form.consent;
        emitted.marketing = this.form.marketing;
        // check the box to continue
        if (!emitted.consent) {
          this.selected_error = true;
          return false;
        }
      } else if (this.registration_method.registration_method_id == "4") {
        emitted.access_code = this.access_code;
      }
      this.$emit("emitRegistrationMethodData", emitted);
    },
  },
};
</script>
<style>
input {
  background: black;
  color: white;
}

.rm a,
.rm span.text-link {
  color: #d184c2;
  text-decoration: underline;
  cursor: pointer;
}

.rm .help-text {
  color: #000000;
  padding: 5px 0;
  font-size: 14px;
  font-style: italic;
  text-align: center;
  display: block;
}

.rm .error-text {
  text-transform: uppercase;
  position: absolute;
  line-height: 1;
  right: 12px;
  top: 12px;
  padding: 8px 8px 7px 8px;
  background: red;
  color: #ffffff;
  border-radius: 3px;
  text-align: left;
  font-weight: bold;
  font-size: 12px;
}

.rm .rm-header {
  background: black;
  border-top-width: 1px;
  border-top-style: solid;
  cursor: pointer;
}

.rm .rm-form {
  background: black;
  border-top-width: 1px;
  border-top-style: solid;
  width: 50%;
}

.rm:last-child {
  border-bottom-width: 1px;
  border-bottom-style: solid;
}

.rm .input-text {
  border-radius: 0;
  border: none;
  border-bottom: 1px solid #cccccc;
  color: white;
  overflow: visible;
  width: 100%;
  padding: 15px;
  font-size: 16px;
}

.rm .btn {
  background: #34cad2;
  border: 1px solid rgba(0, 0, 0, 0.3);
}

.rm .btn {
  width: 100%;
  padding: 20px;
  cursor: pointer;
  font-size: 20px;
  font-weight: bold;
}

.rm .btn.rounded {
  border-radius: 6px;
}

.rm label {
  display: inline-block;
  padding: 0px;
  width: 100%;
  font-size: 18px;
}

.rm label span {
  font-size: 16px;
  font-weight: normal;
}

.rm .input-radio {
  display: inline-block;
  padding: 10px;
}

@media screen and (max-device-width: 800px) {
  .rm .rm-form {
    width: 75%;
    margin: 0 auto;
  }
}

.checkbox-row {
  padding: 1rem 0 0;
  text-align: left;
}

.checkbox-row input {
  margin-right: 10px;
}

.input-text {
  text-align: center;
}

.top-btn {
  margin-top: 1rem;
}
</style>
